<nz-footer>
  <div class="first-row" nz-row>
    <div class="first-col" nz-col nzSpan="12">
      <div class="logo">
        <img src="../../../../public/assets/images/logo_redion_white.png" alt="Logo">
      </div>
      <p>{{ 'footer.address' | translate }}</p>
    </div>
    @if (isLogged) {
      <div class="second-col" nz-col nzSpan="12">
        <a class="category" [href]="getLink('who')">{{ 'footer.who' | translate }}</a>
        <a class="category" [href]="getLink('condition')">{{ 'footer.condition' | translate }}</a>
        <a class="category" [href]="getLink('faq')">{{ 'footer.faq' | translate }}</a>
        <a class="category" [href]="getLink('mail')">{{ 'footer.mail' | translate }}</a>
      </div>
    }
    @if (!isLogged) {
      <div nz-col [nzXs]="24" [nzLg]="24" [nzXl]="24" class="text-not-logged">
        <!--<p>L’impresa opera attraverso il sito in qualità di distributore di prodotti assicurativi</p>-->
      </div>
    }
    <div class="first-col" nz-col nzSpan="12">
      <p>{{ 'footer.copyright' | translate }}</p>
    </div>
    <div class="second-col" nz-col nzSpan="12">
      <a class="section" href="https://www.redion.it/intermediari-redion-italy-services">{{ 'footer.intermediaries' | translate }}</a>
      <a class="section" href="https://www.redion.it/dati-societari-services">{{ 'footer.company' | translate }}</a>
      <a class="section" href="https://redion.it/privacy-services">{{ 'footer.privacy' | translate }}</a>
      <a class="section" [routerLink]="['/cookies']">{{ 'footer.cookies' | translate }}</a>
      <a class="section" href="https://www.redion.it/accessibilita">{{ 'footer.accessibility' | translate }}</a>
    </div>
  </div>
</nz-footer>
